// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-flexibility .survey-options-container.with-image .survey-option,
.page-workout .survey-options-container.with-image .survey-option,
.page-energy-levels .survey-options-container.with-image .survey-option,
.page-water-intake .survey-options-container.with-image .survey-option{
    padding: 24px 12px;
}

.page-survey.page-flexibility .survey-options-container .image-container,
.page-survey.page-workout .survey-options-container .image-container,
.page-survey.page-energy-levels .survey-options-container .image-container,
.page-survey.page-water-intake .survey-options-container .image-container {
    position: absolute;
    top: 275px;
    right: 0;
    left: 0;
}

.page-survey.page-flexibility .survey-options-container .image-container img,
.page-survey.page-workout .survey-options-container .image-container img,
.page-survey.page-energy-levels .survey-options-container .image-container img,
.page-survey.page-water-intake .survey-options-container .image-container img {
    width: 375px;
    margin: auto;
}

.page-survey.page-flexibility .policy-container {
    margin-top: 280px;
}
.page-survey.page-workout .policy-container {
    margin-top: 120px;
}
.page-survey.page-energy-levels .policy-container  {
    margin-top: 170px;
}
.page-survey.page-water-intake .policy-container {
    margin-top: 190px;
}

@media (orientation: landscape) {
    .page-flexibility,
    .page-workout,
    .page-energy-levels,
    .page-water-intake {
       position: relative;
    }
    .page-survey.page-flexibility .survey-options-container .image-container,
    .page-survey.page-workout .survey-options-container .image-container,
    .page-survey.page-energy-levels .survey-options-container .image-container,
    .page-survey.page-water-intake .survey-options-container .image-container {
        position: absolute;
        top: 160px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/pages-with-background-img.css"],"names":[],"mappings":"AAAA;;;;IAII,kBAAkB;AACtB;;AAEA;;;;IAII,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,OAAO;AACX;;AAEA;;;;IAII,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI;;;;OAIG,kBAAkB;IACrB;IACA;;;;QAII,kBAAkB;QAClB,UAAU;IACd;AACJ","sourcesContent":[".page-flexibility .survey-options-container.with-image .survey-option,\n.page-workout .survey-options-container.with-image .survey-option,\n.page-energy-levels .survey-options-container.with-image .survey-option,\n.page-water-intake .survey-options-container.with-image .survey-option{\n    padding: 24px 12px;\n}\n\n.page-survey.page-flexibility .survey-options-container .image-container,\n.page-survey.page-workout .survey-options-container .image-container,\n.page-survey.page-energy-levels .survey-options-container .image-container,\n.page-survey.page-water-intake .survey-options-container .image-container {\n    position: absolute;\n    top: 275px;\n    right: 0;\n    left: 0;\n}\n\n.page-survey.page-flexibility .survey-options-container .image-container img,\n.page-survey.page-workout .survey-options-container .image-container img,\n.page-survey.page-energy-levels .survey-options-container .image-container img,\n.page-survey.page-water-intake .survey-options-container .image-container img {\n    width: 375px;\n    margin: auto;\n}\n\n.page-survey.page-flexibility .policy-container {\n    margin-top: 280px;\n}\n.page-survey.page-workout .policy-container {\n    margin-top: 120px;\n}\n.page-survey.page-energy-levels .policy-container  {\n    margin-top: 170px;\n}\n.page-survey.page-water-intake .policy-container {\n    margin-top: 190px;\n}\n\n@media (orientation: landscape) {\n    .page-flexibility,\n    .page-workout,\n    .page-energy-levels,\n    .page-water-intake {\n       position: relative;\n    }\n    .page-survey.page-flexibility .survey-options-container .image-container,\n    .page-survey.page-workout .survey-options-container .image-container,\n    .page-survey.page-energy-levels .survey-options-container .image-container,\n    .page-survey.page-water-intake .survey-options-container .image-container {\n        position: absolute;\n        top: 160px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
